import React from 'react'

function TenderTextBroad() {
  return (
    <embed src="\pdfs\EAT1.2.6_BF-V_Broad_multiplex_outlet_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextBroad